import { render, staticRenderFns } from "./IbApprovalAlert.vue?vue&type=template&id=22b23d0e"
import script from "./IbApprovalAlert.vue?vue&type=script&lang=js"
export * from "./IbApprovalAlert.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports